<div class="header-body-separator">
   <div *ngIf="accessCode" class="exam-session">
      <div class="access">
         <label i18n>Access code:</label> {{accessCode}}
      </div>
      <app-candidates-in-exam  class="cie"></app-candidates-in-exam>
      <app-chatnotification [accessCode]="accessCode"></app-chatnotification>
   </div>
</div>
